import { render, staticRenderFns } from "./PayerSelector.vue?vue&type=template&id=312e9e6f&scoped=true"
import script from "./PayerSelector.vue?vue&type=script&lang=js"
export * from "./PayerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e9e6f",
  null
  
)

export default component.exports